module.exports = __webpack_public_path__ + "img/ditu.3a53d283.png";